import React, { useState, useContext } from "react";
import Context from "../../../../../Context";
import Blocker from "../../../../Misc/Blocker";
import DefaultNotFound from "../../../../Misc/DefaultNotFound";

import RecursiveTreeView from "./RecursiveTreeView";
import EditModal from "./EditModal";
import AddModal from "./AddModal";

function buildPath(subkey, registryKeys) {
  let path = [];
  let keys = registryKeys || [];
  if (keys[subkey]) {
    let { parent, level, key } = keys[subkey];
    path.push(key);
    while (level > 1 && parent) {
      let parentItem = keys[parent];
      if (parentItem) {
        level = parentItem.level;
        parent = parentItem.parent;
        path.push(parentItem.key);
      } else {
        break;
      }
    }
  }
  return path.reverse();
}

function getRoot(subkey, keys) {
  if (Array.isArray(keys)) {
    if (keys[subkey]) {
      if (keys[subkey].level === 0) return keys[subkey].key;
      let root = keys[subkey].root;
      if (keys[root]) {
        return keys[root].key;
      }
    }
  }
}

function ListView(props) {
  const cx = useContext(Context);
  let items = [];

  if (props.data) {
    for (let node in props.data) {
      items.push(props.data[node]);
    }
  }

  if (props.subkey) {
    let filteredItems = [];
    let filtered = items.filter((item) => item.subkey === props.subkey);
    filtered.forEach((node) => filteredItems.push(node));
    items = filteredItems;
  }

  const [activeItem, setActiveItem] = useState({});
  const [showModal, setModalShow] = useState(false);

  function showItemValue(item) {
    let value = item.value || {};
    let displayValue = "";
    if (value.vtype === 0) displayValue = value.vinteger;
    if (value.vtype === 1) displayValue = value.vnumeric;
    if (value.vtype === 2) {
      let date = new Date(value.vdatetime);
      displayValue = `${date.toLocaleString()}`;
    }
    if (value.vtype === 3) displayValue = value.vstring;
    if (value.vtype === 4)
      displayValue = value.vboolean === true ? "Да" : "Нет";
    return displayValue;
  }

  function editClick(id) {
    setActiveItem(props.data[id]);
    setModalShow(true);
  }

  async function deleteClick(id) {
    let item = props.data[id];
    if (item) {
      let path = Array.isArray(item.path) ? item.path.join("\\") : "";
      cx.ask(
        `Вы действительно хотите удалить значение ${path} ${props.data[id].valuename}`,
        "Удаление значения",
        "question"
      ).then(function (result) {
        if (result.value) {
          props.onDelete(id);
        }
      });
    }
  }

  async function deleteKeyClick(key, subkey) {
    if (props.keys[subkey]) {
      cx.ask(
        `Вы действительно хотите удалить ключ ${props.keys[subkey].key}, все его подключи и значения?`,
        "Удаление ключа",
        "question"
      ).then(function (result) {
        if (result.value) {
          props.onDeleteKey(key, subkey);
        }
      });
    }
  }

  let path = buildPath(props.subkey, props.keys).join("\\");
  let pkey = getRoot(props.subkey, props.keys);

  let itemsList = items.length ? (
    <table className="table mt-6">
      <tbody>
        {items.map((item) => {
          return (
            <tr
              className={`${
                item.id === activeItem.id && showModal ? "bg-light" : ""
              }`}
              key={item.id}
            >
              <td>{item.valuename}</td>
              <td>{showItemValue(item)}</td>
              <td align="right">
                <button
                  className="btn p-1 text-hover-primary"
                  onClick={() => editClick(item.id)}
                >
                  <i className="flaticon2-writing"></i>
                </button>
                <button
                  className="btn p-1 text-hover-danger"
                  onClick={() => deleteClick(item.id)}
                >
                  <i className="flaticon2-rubbish-bin"></i>
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  ) : (
    <DefaultNotFound message="В этом ключе реестра не содержится значений" />
  );

  if (!props.subkey) itemsList = null;

  return (
    <div>
      <EditModal
        item={activeItem}
        defaultValue={showItemValue(activeItem)}
        onHide={() => setModalShow(false)}
        show={showModal}
        onEdit={props.onEdit}
        key={JSON.stringify(activeItem)}
      />
      {path ? (
        <div className="d-flex align-items-center justify-content-between">
          <span className="h3 mb-5 text-muted">{path}</span>
          <div>
            <button
              className="btn btn-light  p-2 mr-2"
              onClick={() =>
                props.onShowAdd(
                  path !== "CURRENT_CONFIG" && path !== "CURRENT_USER"
                    ? path
                    : "",
                  pkey
                )
              }
            >
              <span className="flaticon2-add-1 px-2 align-middle  "></span>
            </button>
            <button
              className="btn btn-light   text-hover-danger p-2"
              onClick={() => deleteKeyClick(pkey, props.subkey)}
            >
              <span className="flaticon2-rubbish-bin  px-2  align-middle  "></span>
            </button>
          </div>
        </div>
      ) : null}
      {itemsList}
    </div>
  );
}

function RegistyCrumbs() {
  let cx = useContext(Context);
  cx.breadCrumbsAdd("Реестр");
  return <div></div>;
}

class Registry extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      registryKeys: [],
      registryValues: [],
      registryValuesList: [],
      pending: false,
      subkey: false,
      addShow: false,
      addShowSubkey: "",
      addShowKey: "",
    };
  }

  componentDidMount() {
    this.load();
  }

  delete = async (id) => {
    let item = this.state.registryValues[id];
    if (item) {
      this.setState({ pending: true });
      let sPath = Array.isArray(item.path) ? item.path.join("\\") : "";
      let result = await this.context.api.q("/registry/delete/value", {
        key: item.keyname,
        subkey: sPath,
        name: item.valuename,
      });
      if (result !== false) {
        await this.load();
        this.context.toast(`Элемент реестра удален`, "success");
      } else {
        this.context.toast(`Не удалось удалить элемент реестра `, "error");
      }
      this.setState({ pending: false });
    }
  };

  deleteKey = async (key, subkey) => {
    this.setState({ pending: true });
    let arPath = buildPath(subkey, this.state.registryKeys);
    let sPath = Array.isArray(arPath) ? arPath.join("\\") : "";
    let result = await this.context.api.q("/registry/delete/tree", {
      key: key,
      subkey: sPath,
    });
    if (result !== false) {
      await this.load();
      this.context.toast(`Ключ реестра удален`, "success");
    } else {
      this.context.toast(`Не удалось удалить ключ реестра `, "error");
    }
    this.setState({ pending: false });
  };

  load = async () => {
    this.setState({ pending: true });
    let registryKeys = [];
    let registryValues = [];
    let registryValuesList = [];

    let registryKeysGot = await this.context.api.q("/registry/key");
    if (registryKeysGot !== false) {
      if (Array.isArray(registryKeysGot)) {
        registryKeysGot.forEach((node) => {
          registryKeys[node.id] = node;
        });
      }
    }

    let id_CURRENT_CONFIG = 0;
    let id_CURRENT_USER = 0;

    let registryValuesGot = await this.context.api.q("/registry/value");
    if (registryValuesGot !== false) {
      if (registryValuesGot["id"]) registryValuesGot = [registryValuesGot];
      if (Array.isArray(registryValuesGot)) {
        registryValuesGot.forEach((node) => {
          if (node.keyname === "CURRENT_CONFIG") id_CURRENT_CONFIG = node.key;
          if (node.keyname === "CURRENT_USER") id_CURRENT_USER = node.key;
          registryValues[node.id] = node;
          registryValues[node.id].path = buildPath(node.subkey, registryKeys);
        });
        registryValuesList = registryValues;
      }
      if (id_CURRENT_CONFIG)
        registryKeys[id_CURRENT_CONFIG] = {
          id: id_CURRENT_CONFIG,
          key: "CURRENT_CONFIG",
          level: 0,
        };
      if (id_CURRENT_USER)
        registryKeys[id_CURRENT_USER] = {
          id: id_CURRENT_USER,
          key: "CURRENT_USER",
          level: 0,
        };
    }

    this.setState({
      registryKeys,
      registryValues,
      registryValuesList,
      pending: false,
    });
  };

  showAdd = (subkey = "", key = "") => {
    this.setState({ addShow: true, addShowSubkey: subkey, addShowKey: key });
  };

  addItem = async () => {
    this.load();
  };

  editItem = (item, value) => {
    this.load();
  };

  navigate = async (id) => {
    let subkey = id || this.state.subkey;
    this.setState({ subkey });
  };

  render() {
    let nothingMessage = false;
    /*  let nothingMessage =
      !this.state.registryKeys.length && !this.state.pending ? (
        <div className="">
          <DefaultNotFound message="Реестр пуст" />

          <div className="d-flex align-items-center">
            <button className="btn btn-light" onClick={() => this.showAdd()}>
              <span className="flaticon2-add-1 mr-2"></span> Добавить ключ
            </button>
          </div>
        </div>
      ) : null;*/

    let body = !nothingMessage ? (
      <div className="row h-100">
        <div className="col-lg-3 border-right mb-3 m-lg-0  ">
          <RecursiveTreeView
            changeFn={(id) => this.navigate(id)}
            data={this.state.registryKeys}
          />
        </div>
        <div className="col-lg-9">
          <ListView
            listKey="RegistyList"
            subkey={this.state.subkey}
            keys={this.state.registryKeys}
            data={this.state.registryValues}
            onEdit={(item, value) => this.editItem(item, value)}
            onShowAdd={(subkey, key) => this.showAdd(subkey, key)}
            onDelete={this.delete}
            onDeleteKey={this.deleteKey}
          />
        </div>
      </div>
    ) : null;

    return (
      <>
        <RegistyCrumbs />
        <AddModal
          show={this.state.addShow}
          onHide={() => this.setState({ addShow: false })}
          subkey={this.state.addShowSubkey}
          pkey={this.state.addShowKey}
          key={`${this.state.addShowSubkey}${this.state.addShowKey}`}
          onAdd={this.addItem}
        />
        <Blocker on={this.state.pending}>
          <div className="card card-custom gutter-b card-stretch  ">
            <div className="card-body  ">
              {nothingMessage}
              {body}
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
export default Registry;
